export default __webpack_public_path__ + "static/media/boat-badge.dee5108b.webp";